import React from 'react'

import VictorDalton from '../../assets/VictorDalton.png'
import { Container, ContentWrapper } from './styles'

const SignatureBanner: React.FC = () => {
  return (
    <Container>
      <ContentWrapper>
        <img src={VictorDalton} alt="Victor Dalton" className="desktop" />
        <div>
          <h2>Tenha acesso completo a todo o conteúdo do Direção Concursos.</h2>
          <p>Acesse todas as aulas e cursos do site em um único lugar.</p>
        </div>
        <div>
          <a href="https://assinaturas.direcaoconcursos.com.br/" target="_blank" rel="noreferrer">
            Saiba mais
          </a>
          <img src={VictorDalton} alt="Victor Dalton" className="mobile" />
        </div>
      </ContentWrapper>
    </Container>
  )
}

export default SignatureBanner
